import { render, staticRenderFns } from "./ShareHeader.vue?vue&type=template&id=7bbe7c56&scoped=true"
import script from "./ShareHeader.vue?vue&type=script&lang=js"
export * from "./ShareHeader.vue?vue&type=script&lang=js"
import style0 from "./ShareHeader.vue?vue&type=style&index=0&id=7bbe7c56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbe7c56",
  null
  
)

export default component.exports